package dk.smark.demo.map

import dk.smark.demo.location.GenericLocation
import dk.smark.demo.location.LocationError
import dk.smark.demo.location.LocationResult
import dk.smark.demo.location.createLocationService
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update


class MapController(
    initialState: MapUiState = MapUiState(),
) {
    private val locationService = createLocationService()

    private val _message = MutableStateFlow<String?>(null)
    val message: StateFlow<String?> = _message.asStateFlow()

    private val _state = MutableStateFlow(initialState)
    val state: StateFlow<MapUiState> = _state.asStateFlow()

    private val _commands = MutableSharedFlow<MapCommand>(extraBufferCapacity = 8)
    val commands: SharedFlow<MapCommand> = _commands.asSharedFlow()

    fun setMarkers(markers: List<MapMarker>) {
        _state.update { it.copy(markers = markers) }
    }

    fun setPolylines(polylines: List<MapPolyline>) {
        _state.update { it.copy(polylines = polylines) }
    }

    fun moveCamera(camera: MapCameraState) {
        _state.update { it.copy(camera = camera) }
        _commands.tryEmit(MapCommand.MoveCamera(camera))
    }

    fun zoomIn() {
        _commands.tryEmit(MapCommand.ZoomIn)
    }

    fun zoomOut() {
        _commands.tryEmit(MapCommand.ZoomOut)
    }

    fun onEvent(event: MapEvent) {
        when (event) {
            MapEvent.MapLoaded -> {
                _state.update { it.copy(mapReady = true) }
            }

            is MapEvent.MapClicked -> {
                // Hook for dropping a pin, reverse geocoding, etc.
            }

            is MapEvent.MarkerClicked -> {
                _state.update { state ->
                    state.copy(
                        markers = state.markers.map { marker ->
                            marker.copy(isSelected = marker.id == event.markerId)
                        }
                    )
                }
            }

            is MapEvent.CameraMoved -> {
                _state.update { it.copy(camera = event.camera) }
            }

            else -> {}
        }
    }

    fun pinUserLocation(lat: Double, lon: Double) {
        _state.update { state ->
            state.copy(
                // markers = state.markers + MapMarker(id = "user_location_${state.markers.size}", LatLon(lat, lon), "You are here", true)
                markers = listOf(MapMarker(id = "user_location_${state.markers.size}", LatLon(lat, lon), "You are here", true))
            )
        }
        moveCamera(_state.value.camera.copy(center = LatLon(lat, lon)))
    }

    fun renderTrack(track: List<GenericLocation>) {
        if (track.size >= 2) {
            setPolylines(
                listOf(
                    MapPolyline(
                        id = "user_track",
                        points = track.map { LatLon(it.latitude, it.longitude) }
                    )
                )
            )
        }
    }
}